var _defs, _use;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    focusable: "false"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M.77415 18a.79183.79183 0 01-.38708-.10285C.1474 17.75927-.00018 17.5044 0 17.22863V.7728C-.00018.49703.1474.24215.38707.10427c.23734-.13903.53165-.13903.76899 0L15.60678 8.3322c.24283.13552.39322.3912.39322.66852 0 .27733-.1504.533-.39322.66852L1.15606 17.89715A.7711.7711 0 01.77415 18z",
    id: "play_svg__a"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#play_svg__a",
    className: "play_svg__outline",
    transform: "translate(6 3)"
  })));
}

export default __webpack_public_path__ + "ondemand/static/8b50f6e88/icons/play.svg";
export { SvgPlay as ReactComponent };